var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrameD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1089_3578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 16C32 24.8368 24.8368 32 16 32C7.1632 32 0 24.8368 0 16C0 7.1632 7.1632 0 16 0C24.8368 0 32 7.1632 32 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1335 16H13.5999V11.2H18.1335C18.77 11.2 19.3805 11.4529 19.8306 11.9029C20.2806 12.353 20.5335 12.9635 20.5335 13.6C20.5335 14.2365 20.2806 14.847 19.8306 15.2971C19.3805 15.7471 18.77 16 18.1335 16ZM18.1335 8H10.3999V24H13.5999V19.2H18.1335C19.6187 19.2 21.0431 18.61 22.0933 17.5598C23.1435 16.5096 23.7335 15.0852 23.7335 13.6C23.7335 12.1148 23.1435 10.6904 22.0933 9.6402C21.0431 8.59 19.6187 8 18.1335 8Z",
    fill: "#170029"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1089_3578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameD);
export default __webpack_public_path__ + "static/media/frame_d.a3b203e5107cc1a62520dd699cb0bc27.svg";
export { ForwardRef as ReactComponent };